import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import styled from "styled-components";

import { lighten, darken } from "../actions";

import Container from "../containers/container";
import Hero from "../containers/hero"
import About from "../containers/about";

import Button from "../components/Button";
import ProjectCard from "../components/ProjectCard"

import spotify from "../images/spotify.svg";
import soundcloud from "../images/soundcloud.svg";


const Work = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 80px;
  width: 100%;
  margin-bottom: 96px;

  @media (max-width: 1024px) {
    margin: 40px 0;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;

  & > * {
    margin-right: 16px;
  }

  @media (max-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 248px;
    a {
      margin-bottom: 10px;
    }
  }
  @media (max-width: 425px) {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 248px;
    a {
      margin-bottom: 10px;
    }
  }
`;

const EmbedContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  background: var(--panel-bg);
  padding: 24px;
  border-radius: 16px;
  border: 1px solid rgba(150, 150, 150, 0.1);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 12px;
    border-radius: 12px;
  }

  iframe {
    display: block;
    width: 100%;
  }
`;

const Music = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <>
      <a className="anchor" id="about"></a>
      <Container>
        <Hero>
          <About>
            <h1>music</h1>
            <ButtonRow>
              <a
                target="_blank"
                href="https://soundcloud.com/stanfordwhu"
                rel="noopener noreferrer"
              >
                <Button>
                  soundcloud <img src={soundcloud} alt="SoundCloud" />
                </Button>
              </a>
            </ButtonRow>
          </About>
        </Hero>
        <a className="anchor" id="work"></a>
        <Work>
          <EmbedContainer>
            <iframe 
              data-testid="embed-iframe" 
              style={{ borderRadius: '12px', border: 0 }} 
              src="https://open.spotify.com/embed/album/6cHfuBysnhcci6A3pZe7AA?utm_source=generator&si=50b563968ab84166" 
              width="100%" 
              height="352" 
              allowFullScreen={true} 
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
              title="Spotify Album Embed"
            ></iframe>
          </EmbedContainer>

          <EmbedContainer>
            <iframe 
              width="100%" 
              height="300" 
              scrolling="no" 
              frameBorder="no" 
              allow="autoplay; encrypted-media" 
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A1566537487&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
              style={{ border: 0, borderRadius: '12px' }}
              title="SoundCloud Embed"
            ></iframe>
            <div style={{ fontSize: '10px', color: '#cccccc', lineBreak: 'anywhere', wordBreak: 'normal', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontFamily: 'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif', fontWeight: 100, marginTop: '12px', opacity: 0.8, paddingLeft: '4px' }}>
              <a href="https://soundcloud.com/stanfordwhu" title="stanfordwhu" target="_blank" rel="noopener noreferrer" style={{ color: '#cccccc', textDecoration: 'none' }}>stanfordwhu</a> · <a href="https://soundcloud.com/stanfordwhu/first-snow" title="First Snow" target="_blank" rel="noopener noreferrer" style={{ color: '#cccccc', textDecoration: 'none' }}>First Snow</a>
            </div>
          </EmbedContainer>
        </Work>
        <a className="anchor" id="contact"></a>
      </Container>
    </>
  );
};

export default Music;
